// extracted by mini-css-extract-plugin
export var auto = "_2p-1";
export var spinner = "_2p-0";